export default class Constants {
  public static readonly HTTP_CODE_200 = 200;
  public static readonly DEFAULT_ERROR_MESSAGE = 'Щось пішло не так. Спробуйте ще раз. У разі помилки зв\'яжіться з адміністратором'
}
